<template>
  <!-- Corpo -->
  <div class="bg-white rounded-lg shadow-md p-6 mb-4">
    <div class="flex justify-center">
      <img :src="`/images/icons/reception-digitale/loghi-aziendali/`+$page.props.customer?.slug+`/loghi.png`" class="h-20">
    </div>
  </div>
  
  <div class="bg-white rounded-lg shadow-md p-6 mb-4">
    <h1 v-if="!requestTakenInCharge" class="text-center text-2xl font-bold mb-4">
      Un referente è stato avvisato della vostra Richiesta di Assistenza.
      <br>
      <span class="text-base text-gray-600">A staff member has been notified of your Assistance Request.</span>
    </h1>
    <h1 v-else class="text-center text-2xl font-bold mb-4">
      Un referente ha preso in carico la tua richiesta di assistenza!
      <br>
      <span class="text-base text-gray-600">A staff member has taken charge of your assistance request!</span>
    </h1>
    
    <p v-if="!requestTakenInCharge" class="text-center text-xl">
      Attendere prego.
      <br>
      <span class="text-base text-gray-600">Please wait.</span>
    </p>
    <p v-else class="text-center text-xl">
      Attendilo qui alla reception, arriverà a breve
      <br>
      <span class="text-base text-gray-600">Wait here at the reception, they will arrive shortly.</span>
    </p>
  </div>

  <div
    style="position: fixed; bottom: 20px; right: 20px; width: 60px; height: 60px; z-index: 50; cursor: pointer; opacity: 0.1; border: 2px solid #888; border-radius: 12px;"
    @click="easterEggConfirmRfa"
  ></div>
</template>

<script>
import { router } from '@inertiajs/vue3';
import LayoutNoHeader from '@/Layouts/LayoutNoHeader.vue';
import axios from 'axios';

export default {
  layout: LayoutNoHeader,
  props: ['requestForAssistance'],
  data() {
    return {
      pollingInterval: null,
      requestTakenInCharge: false
    };
  },
  mounted() {
    // Start polling every 5 seconds to check visit status
    this.pollingInterval = setInterval(() => {
      this.checkStatus();
    }, 5000);
  },
  beforeUnmount() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  },
  methods: {
    async checkStatus() {
      try {
        const response = await axios.get(route('modules.rd-dettagli-richiesta-assistenza', { requestForAssistance: this.requestForAssistance }));

        if (response.data.confirmed && response.data.confirmed === true) {
          // Mostra il messaggio che la richiesta è stata presa in carico
          this.requestTakenInCharge = true;
          
          // Ferma il polling
          clearInterval(this.pollingInterval);
          
          // Reindirizza automaticamente dopo 10 secondi
          setTimeout(() => {
            router.visit(route('modules.home', { slug: 'reception-digitale' }));
          }, 10000); // Reindirizza dopo 10 secondi
        }
      } catch (error) {
        console.error('Error checking request status:', error);
      }
    },
    async easterEggConfirmRfa() {
      try {
        const response = await axios.get(
          route('modules.rd-rfa-confirm', { requestForAssistance: this.requestForAssistance })
        );
        router.visit(route('modules.home', { slug: 'reception-digitale' }));
      } catch (error) {
      }
    }
  }
};
</script>
